import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MedReviewService } from '../../services/med-review.service';
import { StringUtilsService } from '../../../../../core/services/string-utils.service';
import { of } from 'rxjs';
import { retry, take, tap } from 'rxjs/operators';
import { GeneralAutocompleteComponent } from '../../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { LayoutUtilsService, MessageType } from '../../../../../core/_base/crud';
import { select, Store } from '@ngrx/store';
import { currentUser } from '../../../../../core/auth';
import { AppState } from '../../../../../core/reducers';
import { TemplateService } from '../../../../../core/lists/_services/template.service';
import { TaskService } from '../../../../../core/timeline';
import { DRPClassification } from '../../models';
import { DRP, Task } from '../../../calendar/models';
import { TaskDefaultView, TaskPriority, TaskStatus } from '../../../calendar/enums';

@Component({
  selector: 'kt-custom-drp',
  templateUrl: './custom-drp.component.html',
})
export class CustomDrpComponent implements OnInit {
  interventionBody = [];
  @ViewChild('teamAutocomplete') teamAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('interventionCodeAutocomplete')
  interventionCodeAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('causeAutocomplete') causeAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('drpClassificationAutocomplete')
  drpClassificationAutocomplete: GeneralAutocompleteComponent;
  currentUser;
  hasFormErrors = false;
  error = '';
  private interventionForMap = [];
  private defaultTeams: any;
  problemCodeNotExist = true;
  templateAutocompleteCall;
  teamExist = true;
  @ViewChild('templateAutocomplete') templateAutocomplete: GeneralAutocompleteComponent;
  fillDatePlz = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CustomDrpComponent>,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private medReviewService: MedReviewService,
    public stringUtils: StringUtilsService,
    private layoutUtilsService: LayoutUtilsService,
    private store: Store<AppState>,
    private templateService: TemplateService,
    private taskService: TaskService,
  ) {}
  levelExist = true;
  manageForm: FormGroup;
  duration = 0;
  drug;
  durationCtrl = new FormControl();
  causes = [{ id: 1, cause_code: 'test' }];
  intervention_levels = [{ id: 1, level_code: 0, level: 'No intervention' }];
  classification_categories = [{ id: 1, classificationCode: 0, classificationDescription: '' }];
  interventions = [];
  filterInterventionCodeFn = this.medReviewService.getInterventionCodesAutocomplete.bind(
    this.medReviewService,
    '',
  );
  filterTeamFn = this.medReviewService.getTeamAutocomplete.bind(this.medReviewService);
  prescription: any;
  risks = ['LOW', 'MODERATE', 'HIGH', 'SEVERE'];
  requiredTeam = false;
  requiredTemplate = false;
  requiredIntCode = false;
  getDRPClassificationAutocomplete = this.medReviewService.searchDRPClassification.bind(
    this.medReviewService,
  );
  loadItems = (t) => {
    return this.medReviewService
      .getCauseAutocomplete(this.manageForm.get('problem_code')?.value, t)
      .pipe(
        tap((data) => {
          data.map((val: any) => {
            return {
              intervention_values: val.intervention_values,
              description: val.description,
              cause_code: val.cause_code,
              id: val.id,
            };
          });
        }),
      );
  };

  ngOnInit(): void {
    this.store.pipe(select(currentUser)).subscribe((res) => {
      if (res) {
        this.currentUser = res;
      }
    });
    this.medReviewService.getInterventionLevelsSelect().subscribe((res) => {
      this.intervention_levels = res;
    });
    this.medReviewService.getClassificationCategories().subscribe((res) => {
      this.classification_categories = res;
    });
    if (this.data.from === 'MEDREVIEW') {
      this.drug = this.data.card.prescription?.drug;
      this.prescription = this.data.card?.prescription;
    }
    if (this.data.from === 'PRESCRIPTIONS_LIST') {
      this.drug = this.data.prescription.drug;
      this.prescription = this.data?.prescription;
    }

    this.manageForm = this.fb.group({
      due_date: [undefined, Validators.required],
      category: [undefined, Validators.required],
      title: [undefined, Validators.required],
      text: [undefined, Validators.required],
      risk: [undefined, Validators.required],
      problem_code: [undefined, Validators.required],
      causes: [],
      team_responsible: [],
      intervention_code: [],
      intervention_level: [],
      note: [],
      template: [],
    });
    this.medReviewService.getDefaultTeam().subscribe((result) => {
      if (result && result[0] && result[0].data) {
        this.defaultTeams = result[0].data;
        this.manageForm.controls.team_responsible.setValue(this.defaultTeams);
        this.teamAutocomplete.setValue(this.defaultTeams);
      }
    });

    this.templateAutocompleteCall = this.templateService.findTaskTemplates.bind(
      this.templateService,
      this.getTemplatesFilter(),
    );

    this.fillDueDate();
  }

  getTemplatesFilter() {
    return { categoryId: this.manageForm.get('team_responsible').value?.id, isIntervention: true };
  }

  fillDueDate() {
    const due_date = new Date();
    const future_date = new Date();
    future_date.setDate(future_date.getDate() + 7);
    const facility_cycle_date = new Date(new Date(this.data.facility_cycle_date + ' UTC'));
    // Today + 5 days if facility cycle day is less than 1 week in the future or there is no facility cycle date for the patient.
    if (!this.data.facility_cycle_date || facility_cycle_date < future_date) {
      due_date.setDate(due_date.getDate() + 5);
      this.manageForm.controls.due_date.setValue(due_date);
      return;
    }
    // Facility Cycle Date – 2 days if facility cycle date.
    const new_due_date = new Date(new Date(this.data.facility_cycle_date + ' UTC'));
    new_due_date.setDate(new_due_date.getDate() - 2);
    this.manageForm.controls.due_date.setValue(new_due_date);
  }
  close() {
    this.dialogRef.close();
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.manageForm.controls[controlName];
    if (!control) {
      return false;
    }
    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  save() {
    const controls = this.manageForm.controls;
    controls.intervention_level.clearValidators();
    controls.intervention_level.updateValueAndValidity();
    controls.note.clearValidators();
    controls.note.updateValueAndValidity();
    this.drpClassificationAutocomplete?.updateValueAndValidity();

    if (this.manageForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    if (this.interventions.length === 0) {
      this.hasFormErrors = true;
      this.error = 'Please Add Interventions';
      return;
    }
    const d = new Date();
    // tslint:disable-next-line:radix
    d.setMonth(d.getMonth() + parseInt(this.durationCtrl.value));
    const causes = [];
    if (this.manageForm.controls.causes.value)
      this.manageForm.controls.causes.value.forEach((ele) => {
        causes.push(ele.id);
      });
    const drpBody = {
      category: this.manageForm.controls.category.value,
      problem_code: this.manageForm.controls.problem_code.value,
      title: this.manageForm.controls.title.value,
      text: this.manageForm.controls.text.value,
      entry_point: this.data.from,
      entry_reference: this.prescription?.id,
      drug_code: this.data.from === 'MEDREVIEW' ? this.data.card.hicl : this.drug.ndc,
      risk: this.manageForm.controls.risk.value,
    };
    const body = {
      causes,
      interventions: this.interventionBody,
    };

    this.medReviewService.createCustomDRP(drpBody, this.data.patient.id).subscribe((drpResult) => {
      this.medReviewService.manageDRP(body, this.data.patient.id, drpResult.id).subscribe((res) => {
        this.layoutUtilsService.showActionNotification(
          'DRP Created Successfully',
          MessageType.Update,
          3000,
          false,
          false,
        );
        this.interventionForMap = res;
        this.dialogRef.close();
        this.createTask(drpResult);
      });
    });
  }

  getTitle() {
    return 'Create Custom DRP';
  }

  addIntervention() {
    this.fillDatePlz = false;
    if (!this.manageForm.controls.due_date.value) {
      this.fillDatePlz = true;
      this.manageForm.controls.due_date.markAsTouched();
      return;
    }
    const team_responsible = this.manageForm.get('team_responsible').value;
    const intervention_code = this.manageForm.get('intervention_code').value;
    const note = this.manageForm.get('note').value;
    const template = this.manageForm.get('template').value;
    const due_date = this.manageForm.get('due_date').value;
    const intervention_level = this.manageForm.get('intervention_level').value;

    if (!team_responsible || !intervention_code || !note || !template || !intervention_level) {
      const controls = this.manageForm.controls;
      controls.intervention_level.setValidators([Validators.required]);
      controls.intervention_level.updateValueAndValidity();
      controls.note.setValidators([Validators.required]);
      controls.note.updateValueAndValidity();
      if (!controls.team_responsible.value) {
        this.requiredTeam = true;
        this.teamAutocomplete.updateValueAndValidity();
      }
      if (!controls.template.value) {
        this.requiredTemplate = true;
        this.templateAutocomplete.updateValueAndValidity();
      }
      if (!controls.intervention_code.value) {
        this.requiredIntCode = true;
        this.interventionCodeAutocomplete.updateValueAndValidity();
      }
      if (!controls.note.value) {
        controls.note.markAsTouched();
      }
      if (!controls.intervention_level.value) {
        controls.intervention_level.markAsTouched();
      }
      return;
    }
    this.interventions.push({
      team_responsible,
      due_date,
      intervention_code,
      note,
    });
    this.interventionBody.push({
      team_responsible: team_responsible.id,
      due_date: this.datePipe.transform(due_date, 'yyyy-MM-dd'),
      intervention_code: intervention_code.id,
      note,
      template_id: template.id,
      doctor_id: this.prescription && this.prescription.doctor ? this.prescription.doctor.id : null,
    });
    this.requiredIntCode = false;
    this.manageForm.controls.intervention_code.setValue(null);
    this.interventionCodeAutocomplete.setValue(null);
    this.manageForm.get('note').reset();
  }

  selectInterventionCode(val) {
    this.manageForm.controls.intervention_code.setValue(val);
  }
  levelSelected() {
    this.filterInterventionCodeFn = this.medReviewService.getInterventionCodesAutocomplete.bind(
      this.medReviewService,
      this.manageForm.controls.intervention_level.value,
    );
    this.manageForm.controls.intervention_code.setValue(null);
    this.interventionCodeAutocomplete.setValue(null);
    this.levelExist = false;
  }
  selectTeam(val) {
    this.manageForm.controls.team_responsible.setValue(val);
    this.teamExist = true;
    if (val) {
      this.teamExist = false;
    }

    this.templateAutocompleteCall = this.templateService.findTaskTemplates.bind(
      this.templateService,
      this.getTemplatesFilter(),
    );
  }

  filterCauseFn(cause: any): string {
    let res = '';
    if (cause && cause.description) {
      res += cause.description;
    }
    return res;
  }

  onCauseChange(value) {
    const causes = value.map((val) => {
      if (val && !val.id) {
        return {
          intervention_values: val.intervention_values,
          description: val.description,
          cause_code: val.cause_code,
          id: val.id,
        };
      }
      return val;
    });
    this.manageForm.controls.causes.setValue(causes);
    this.manageForm.controls.causes.updateValueAndValidity();
  }

  formatNewCauseFn(cause: any) {
    return cause;
  }

  createTask(drp: DRP): void {
    if (this.interventionForMap.length <= 0) return;

    const groupedByInterventionCodeLevel = this.groupBy(
      this.interventionForMap,
      (ele) => ele.intervention_code.level.id,
    );

    for (const level of groupedByInterventionCodeLevel.keys()) {
      const interventions = groupedByInterventionCodeLevel.get(level);

      for (const intervention of interventions) {
        const getTemplate$ = intervention.template_id
          ? this.templateService.getTaskTemplate(intervention.template_id)
          : of({ data: null });

        getTemplate$.pipe(take(1)).subscribe((res1) => {
          const template = res1?.data;
          const task: Task = {
            id: null,
            task_entities: [{ entity_id: this.data.patient?.id }],
            task_tags: [],
            task_attachments: [],
            allow_payment: res1?.data?.allow_payment,
            steps: [
              {
                id: null,
                title: `DRP ${intervention.intervention_code.code} - ${this.drug?.drug || ''}`,
                order: 1,
                default_view: TaskDefaultView.INTERVENTION,
                priority: TaskPriority.MEDIUM,
                progress: TaskStatus.PLANNED,
                office_id: null,
                description: drp.text,
                url_resource: null,
                due_date: this.manageForm.value.due_date
                  ? this.datePipe.transform(
                      this.manageForm.value.due_date,
                      'yyyy-MM-dd HH:mm:ss',
                      'UTC',
                    )
                  : null,
                sequential_order: false,
                task_template: template,
                task_followers: [{ follower_id: this.currentUser?.id }],
                task_responsible_users: [],
                blockers: null,
                check_list: null,
                intervention,
                transaction_form: null,
              },
            ],
          };

          if (
            intervention.intervention_code.level.levelCode === 1 &&
            !!this.prescription?.doctor?.id
          )
            task.task_entities.push({ entity_id: this.prescription.doctor.id });
          if (this.data.patient?.facility_id)
            task.task_entities.push({ entity_id: this.data.patient.facility_id });
          if (drp.category === 'SA') task.steps[0].priority = TaskPriority.HIGH;

          this.taskService
            .createTaskV3(task)
            .pipe(take(1))
            .subscribe((res2) => {
              if (!res2?.data) return;

              const mapping = res2.data.steps
                ?.filter((s) => s.default_view === TaskDefaultView.INTERVENTION)
                .map((s) => ({ task_id: s.id, intervention_id: intervention.id }));

              this.medReviewService
                .mapInterventionToTask(mapping, this.data.patient?.id, drp.id)
                .pipe(take(1), retry(3))
                .subscribe();
            });
        });
      }
    }
  }

  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  onAlertClose() {
    this.hasFormErrors = false;
  }

  onFillClose() {
    this.fillDatePlz = false;
  }

  filterTemplateFn(template: any): string {
    return template ? template.name : '';
  }

  onTemplateChange(val) {
    this.manageForm.get('template').setValue(val);
    this.manageForm.get('template').updateValueAndValidity();
  }

  formatDRPClassificationOption(drpClassification: DRPClassification): string {
    return drpClassification
      ? `${drpClassification.pcne_problem_code} - ${drpClassification.problem}`
      : '';
  }

  handleDRPClassificationChange(drpClassification: DRPClassification): void {
    this.problemCodeNotExist = !drpClassification;
    this.manageForm.get('problem_code').setValue(drpClassification?.pcne_problem_code || '');
    this.causeAutocomplete.setValue([]);
    this.causeAutocomplete.updateValueAndValidity();
  }
}
